import {register} from '../vendor/theme-scripts/theme-sections';
import {slider} from '../features/slider';
import {videoPlay} from '../features/video-play';
import parallaxHero from '../features/parallax-hero';
import {quickAddProduct} from '../features/quick-add';
import {swatchGridSection} from '../features/swatch';

register('custom-content', [slider, videoPlay, parallaxHero, quickAddProduct, swatchGridSection]);
